import * as React from 'react';
import { useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import XSifterQueryService from '../services/XSifterQueryService';
import { ISavedQueries, IXSifterCreateSavedQueryResponse } from '../types/XSifterQueries';
import { Button, Divider, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import SavedQueryRow from './search/SavedQueryRow';
import DeleteQueryConfirmation from './search/DeleteQueryConfirmation';
import { useAppDispatch } from '../store/hooks';
import { setDisplayMessage, setDisplayMessageType } from '../store/XSifterAppReducer';

interface IXSifterAppDashboardProps {
}

const XSifterAppDashboard: React.FC<IXSifterAppDashboardProps> = (props: IXSifterAppDashboardProps) => {
    const queryService = new XSifterQueryService();

    const [savedQueries, setSavedQueries] = useState<ISavedQueries>();
    const [deleteQueryId, setDeleteQueryId] = useState<string | null>(null);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();    
    
    useEffect(() => {
        queryService.getTopSavedQueries()
            .then((response) => {
                setSavedQueries(response);
            })
            .catch((error) => {

            });
    }, []);

    const onCreateNewQuery = (e) => {
        navigate('/app/query');
    }

    const duplicateQuery = (queryId: string) => {
        navigate(`/app/query?queryId=${queryId}&duplicate=true`);
    }

    const onDeleteQuery = (queryId: string) => {
        setDeleteQueryId(queryId);
    }

    const onQueryDeleted = (queryId: string) => {
        if (!queryId)
            return;

        queryService.deleteSavedQuery(queryId)
        .then((response) => {
            dispatch(setDisplayMessage(`Query '${response.title}' was deleted.`));
            dispatch(setDisplayMessageType("success"))
            setDeleteQueryId(null);

            queryService.getTopSavedQueries()
                .then((response) => {
                    setSavedQueries(response);
                })
                .catch((error) => {

                });
        })
    }

    const onDeleteDialogClosed = () => {
        setDeleteQueryId(null);
    }

    return (
        <>
            <h1 style={{ cursor: "pointer" }} onClick={() => navigate("/app/saved")}>Last fetched queries:</h1>
            {savedQueries
            ? 
            <>
                <Table className="x-table-banded">
                    <TableHead>
                        <TableRow>
                            <TableCell>Timestamp</TableCell>
                            <TableCell>Title</TableCell>
                            <TableCell>Estimated Tweets</TableCell>
                            <TableCell>Downloaded Tweets</TableCell>
                            <TableCell>Re-use or Delete Query</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {savedQueries.items.map(x => <SavedQueryRow 
                            key={x.savedQueryId} 
                            item={x} 
                            onDuplicateItem={duplicateQuery} 
                            onDeleteQuery={() => onDeleteQuery(x.savedQueryId)} 
                        />)}
                    </TableBody>
                </Table>
                <DeleteQueryConfirmation queryId={deleteQueryId} onDialogClosed={onDeleteDialogClosed} onDeleteQuery={onQueryDeleted} />
            </>    
            : <em>No queries with downloads to display</em>
            }
        </>
    );
}

export default XSifterAppDashboard;